import { ApPayeeDetail } from 'ap-openapi';
import {
  createContext,
  FC,
  memo,
  PropsWithChildren,
  useContext,
  useState,
} from 'react';

const payeeContext = createContext<ApPayeeDetail | undefined>(undefined);
const setPayeeContext = createContext<
  (payee: ApPayeeDetail | undefined) => void
>(() => {});

type Props = {
  value?: ApPayeeDetail;
};

export const ApPayeeProvider: FC<PropsWithChildren<Props>> = memo(
  ({ children, value }) => {
    const [payee, setPayee] = useState<ApPayeeDetail | undefined>(value);
    return (
      <setPayeeContext.Provider value={setPayee}>
        <payeeContext.Provider value={payee}>{children}</payeeContext.Provider>
      </setPayeeContext.Provider>
    );
  }
);
ApPayeeProvider.displayName = 'ApPayeeProvider';

export const usePayee = () => useContext(payeeContext);
export const useSetPayee = () => useContext(setPayeeContext);
